// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function ProjectAlloted() {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");

//   const admin = JSON.parse(localStorage.getItem("admin"));

//   useEffect(() => {
//     if (!admin) return;

//     axios
//       .get(`https://api.d2associates.in/daso/sitemaster/projects/${admin.id}`)
//       .then((res) => {
//         setProjects(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }, []);

//   const filtered = projects.filter(
//     (p) =>
//       p.project_name.toLowerCase().includes(search.toLowerCase()) ||
//       p.bank_name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2 style={{ marginBottom: "15px" }}>Project Alloted</h2>

//       <div style={card}>
//         <table style={table}>
//           <thead>
//             <tr>
//               <th style={th}>#</th>
//               <th style={th}>Project Name</th>
//               <th style={th}>Bank Name</th>
//               <th style={th}>Branch Name</th>
//               <th style={th}>Date</th>
//                  <th style={th}>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.length === 0 ? (
//               <tr>
//                 <td colSpan="5" style={empty}>
//                   No Projects Found
//                 </td>
//               </tr>
//             ) : (
//                filtered.map((p, index) => (
//                 <tr key={p.id} style={row}>
//                   <td style={td}>{index + 1}</td>

//                   <td style={{ ...td, ...projectCell }}>
//                     <div style={circle}>
//                       {p.project_name.charAt(0).toUpperCase()}
//                     </div>
//                     {p.project_name}
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>
//                   <td style={td}>
//                     {new Date(p.created_at).toLocaleDateString()}
//                   </td>

//                   {/* ✅ Action Button */}
//                   <td style={td}>
//                     <button style={btn}>
//                       Add Project
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default ProjectAlloted;




// const card = {
//   background: "#fff",
//   borderRadius: "12px",
//   padding: "15px",
//   marginTop: "10px",
//   boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "separate",
//   borderSpacing: "0 10px",
// };

// const th = {
//   padding: "12px",
//   textAlign: "left",
//   fontWeight: "600",
//   color: "#444",
// };

// const td = {
//   padding: "12px",
// };

// const row = {
//   background: "#fff",
//   boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
// };

// const empty = {
//   textAlign: "center",
//   padding: "20px",
// };

// const projectCell = {
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const circle = {
//   width: "30px",
//   height: "30px",
//   borderRadius: "50%",
//   background: "#4f6bed",
//   color: "#fff",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontWeight: "bold",
// };
// const btn = {
//   background: "#4f6bed",
//   color: "#fff",
//   border: "none",
//   padding: "6px 12px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };


// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function ProjectAlloted() {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedProject, setSelectedProject] = useState(null);

//   const admin = JSON.parse(localStorage.getItem("admin"));

//   useEffect(() => {
//     if (!admin) return;

//     axios
//       .get(`https://api.d2associates.in/daso/sitemaster/projects/${admin.id}`)
//       .then((res) => {
//         setProjects(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }, []);

//   const filtered = projects.filter(
//     (p) =>
//       p.project_name.toLowerCase().includes(search.toLowerCase()) ||
//       p.bank_name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2 style={{ marginBottom: "15px" }}>Project Alloted</h2>

//       <div style={card}>
//         <table style={table}>
//           <thead>
//             <tr>
//               <th style={th}>#</th>
//               <th style={th}>Project Name</th>
//               <th style={th}>Bank Name</th>
//               <th style={th}>Branch Name</th>
//               <th style={th}>Date</th>
//               <th style={th}>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.length === 0 ? (
//               <tr>
//                 <td colSpan="6" style={empty}>
//                   No Projects Found
//                 </td>
//               </tr>
//             ) : (
//               filtered.map((p, index) => (
//                 <tr key={p.id} style={row}>
//                   <td style={td}>{index + 1}</td>

//                   <td style={{ ...td, ...projectCell }}>
//                     <div style={circle}>
//                       {p.project_name.charAt(0).toUpperCase()}
//                     </div>
//                     {p.project_name}
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>
//                   <td style={td}>
//                     {new Date(p.created_at).toLocaleDateString()}
//                   </td>

//                   <td style={td}>
//                     <button
//                       style={btn}
//                       onClick={() => setSelectedProject(p)}
//                     >
//                       Add Project
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {selectedProject && (
//         <PropertyForm projectId={selectedProject.id} />
//       )}
//     </div>
//   );
// }

// export default ProjectAlloted;


// // ================= FORM =================

// const PropertyForm = ({ projectId }) => {
//   const [form, setForm] = useState({});

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({
//       ...form,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         ...form,

//         project_id: projectId,

//         is_same: form.is_same ? 1 : 0,

//         purchase_amount: Number(form.purchase_amount) || 0,
//         locality_price: Number(form.locality_price) || 0,
//         land_acre: Number(form.land_acre) || 0,
//         land_sqft: Number(form.land_sqft) || 0,
//         floors: Number(form.floors) || 0,

//         documents: form.documents || [],
//         site_images: (form.site_images || []).slice(0, 5),
//       };

//       console.log("FINAL DATA =>", payload);

//       await axios.post("https://api.d2associates.in/daso/property", payload);

//       alert("Saved Successfully");
//     } catch (err) {
//       console.log(err);
//       alert("Error");
//     }
//   };

//   return (
//     <div style={{ marginTop: "20px", ...card }}>
//       <h3>Property Form (Project ID: {projectId})</h3>

//       <input
//         style={input}
//         name="owner_name"
//         placeholder="Owner Name"
//         onChange={handleChange}
//       />

//       <input
//         style={input}
//         name="owner_contact"
//         placeholder="Contact"
//         onChange={handleChange}
//       />

//       <input
//         style={input}
//         name="purchase_amount"
//         placeholder="Amount"
//         onChange={handleChange}
//       />

//       <button style={btn} onClick={handleSubmit}>
//         Submit
//       </button>
//     </div>
//   );
// };


// // ================= STYLES =================

// const card = {
//   background: "#fff",
//   borderRadius: "12px",
//   padding: "15px",
//   marginTop: "10px",
//   boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "separate",
//   borderSpacing: "0 10px",
// };

// const th = {
//   padding: "12px",
//   textAlign: "left",
//   fontWeight: "600",
//   color: "#444",
// };

// const td = {
//   padding: "12px",
// };

// const row = {
//   background: "#fff",
//   boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
// };

// const empty = {
//   textAlign: "center",
//   padding: "20px",
// };

// const projectCell = {
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const circle = {
//   width: "30px",
//   height: "30px",
//   borderRadius: "50%",
//   background: "#4f6bed",
//   color: "#fff",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontWeight: "bold",
// };

// const btn = {
//   background: "#4f6bed",
//   color: "#fff",
//   border: "none",
//   padding: "6px 12px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const input = {
//   display: "block",
//   marginBottom: "10px",
//   padding: "8px",
//   width: "100%",
// };
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function ProjectAlloted() {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedProject, setSelectedProject] = useState(null);

//   const admin = JSON.parse(localStorage.getItem("admin"));

//   useEffect(() => {
//     if (!admin) return;

//     axios
//       .get(`https://api.d2associates.in/daso/sitemaster/projects/${admin.id}`)
//       .then((res) => setProjects(res.data))
//       .catch((err) => console.log(err));
//   }, []);

//   const filtered = projects.filter(
//     (p) =>
//       p.project_name.toLowerCase().includes(search.toLowerCase()) ||
//       p.bank_name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Project Alloted</h2>

//       <div style={card}>
//         <table style={table}>
//           <thead>
//             <tr>
//               <th style={th}>#</th>
//               <th style={th}>Project Name</th>
//               <th style={th}>Bank</th>
//               <th style={th}>Branch</th>
//               <th style={th}>Date</th>
//               <th style={th}>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.map((p, i) => (
//               <tr key={p.id}>
//                 <td style={td}>{i + 1}</td>
//                 <td style={td}>{p.project_name}</td>
//                 <td style={td}>{p.bank_name}</td>
//                 <td style={td}>{p.branch}</td>
//                 <td style={td}>
//                   {new Date(p.created_at).toLocaleDateString()}
//                 </td>
//                 <td style={td}>
//                   <button style={btn} onClick={() => setSelectedProject(p)}>
//                     Add Project
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {selectedProject && (
//         <PropertyForm projectId={selectedProject.id} />
//       )}
//     </div>
//   );
// }

// export default ProjectAlloted;


// // ================= FORM =================
// const PropertyForm = ({ projectId }) => {
//   const [form, setForm] = useState({});

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({
//       ...form,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleSubmit = async () => {
//     const payload = {
//       ...form,
//       project_id: projectId,
//       is_same: form.is_same ? 1 : 0,
//       sewerage: form.sewerage ? 1 : 0,
//       electricity: form.electricity ? 1 : 0,
//       id_proof_verified: form.id_proof_verified ? 1 : 0,

//       purchase_amount: Number(form.purchase_amount) || 0,
//       locality_price: Number(form.locality_price) || 0,
//       land_acre: Number(form.land_acre) || 0,
//       land_sqft: Number(form.land_sqft) || 0,
//       floors: Number(form.floors) || 0,
//     };

//     await axios.post("https://api.d2associates.in/daso/property", payload);
//     alert("Saved Successfully");
//   };

//   return (
//     <div style={card}>
//       <h2 style={title}>Property Inspection Form</h2>

//       {/* OWNER */}
//       <Section title="Owner Details">
//         <Row>
//           <Input name="owner_name" placeholder="Owner Name" onChange={handleChange}/>
//           <Input name="owner_father" placeholder="Father Name" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="owner_contact" placeholder="Contact" onChange={handleChange}/>
//           <Input name="owner_address" placeholder="Address" onChange={handleChange}/>
//         </Row>
//       </Section>

//       {/* BORROWER */}
//       <Section title="Borrower Details">
//         <label>
//           <input type="checkbox" name="is_same" onChange={handleChange}/> Same as Owner
//         </label>
//         <Row>
//           <Input name="borrower_name" placeholder="Borrower Name" onChange={handleChange}/>
//           <Input name="borrower_father" placeholder="Father Name" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="borrower_contact" placeholder="Contact" onChange={handleChange}/>
//           <Input name="borrower_address" placeholder="Address" onChange={handleChange}/>
//         </Row>
//       </Section>

//       {/* LOCATION */}
//       <Section title="Location">
//         <Row>
//           <Input name="latitude" placeholder="Latitude" onChange={handleChange}/>
//           <Input name="longitude" placeholder="Longitude" onChange={handleChange}/>
//         </Row>
//       </Section>

//       {/* PROPERTY */}
//       <Section title="Property Details">
//         <Row>
//           <Input name="sale_deed_no" placeholder="Sale Deed No" onChange={handleChange}/>
//           <Input type="date" name="registration_date" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="purchase_amount" placeholder="Amount" onChange={handleChange}/>
//           <Input name="locality_price" placeholder="Locality Price" onChange={handleChange}/>
//         </Row>
//         <Input name="property_comment" placeholder="Property Comment" onChange={handleChange}/>
//       </Section>

//       {/* LAND */}
//       <Section title="Land Details">
//         <Row>
//           <Input name="khata_no" placeholder="Khata No" onChange={handleChange}/>
//           <Input name="plot_no" placeholder="Plot No" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="village" placeholder="Village" onChange={handleChange}/>
//           <Input name="tahasil" placeholder="Tahasil" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="thana" placeholder="Thana" onChange={handleChange}/>
//           <Input name="district" placeholder="District" onChange={handleChange}/>
//         </Row>
//         <Input name="postal_address" placeholder="Postal Address" onChange={handleChange}/>
//       </Section>

//       {/* AREA */}
//       <Section title="Area">
//         <Row>
//           <Input
//             name="land_acre"
//             placeholder="Acre"
//             onChange={(e) => {
//               const v = e.target.value;
//               setForm({ ...form, land_acre: v, land_sqft: v * 43560 });
//             }}
//           />
//           <Input name="land_sqft" value={form.land_sqft || ""} readOnly />
//         </Row>
//       </Section>

//       {/* BOUNDARY */}
//       <Section title="Boundary">
//         <Row>
//           <Input name="east" placeholder="East" onChange={handleChange}/>
//           <Input name="west" placeholder="West" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="north" placeholder="North" onChange={handleChange}/>
//           <Input name="south" placeholder="South" onChange={handleChange}/>
//         </Row>
//       </Section>
//  <select name="property_types" onChange={handleChange}>
//   <option value="">Select</option>
//   <option value="Urban">Urban</option>
//   <option value="Rural">Rural</option>
//   <option value="Semi-Urban">Semi-Urban</option>
// </select>

      
//       <Section title="Nearby">
//         <Row>
//           <Input name="landmark" placeholder="Landmark" onChange={handleChange}/>
//           <Input name="school_distance" placeholder="School Distance" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="hospital_distance" placeholder="Hospital Distance" onChange={handleChange}/>
//           <Input name="park_distance" placeholder="Park Distance" onChange={handleChange}/>
//         </Row>
//       </Section>

//       {/* ROAD */}
//       <Section title="Road">
//         <Row>
//           <Input name="road_width" placeholder="Road Width" onChange={handleChange}/>
//           <select name="road_type" style={input} onChange={handleChange}>
//             <option>Bitumen</option>
//             <option>Concrete</option>
//             <option>Murrom</option>
//             <option>Fly-ash</option>
//             <option>Earthen</option>
//           </select>
//         </Row>

//         <label>
//           <input type="checkbox" name="sewerage" onChange={handleChange}/> Sewerage
//         </label>
//         <label>
//           <input type="checkbox" name="electricity" onChange={handleChange}/> Electricity
//         </label>
//       </Section>

//       {/* APPROVAL */}
//       <Section title="Approval">
//         <select name="approval_status" style={input} onChange={handleChange}>
//           <option>Approved</option>
//           <option>Not Approved</option>
//         </select>

//         <Row>
//           <Input name="approving_authority" placeholder="Authority" onChange={handleChange}/>
//           <Input name="approval_letter" placeholder="Approval Letter" onChange={handleChange}/>
//         </Row>

//         <Row>
//           <Input type="date" name="approval_date" onChange={handleChange}/>
//           <Input name="far" placeholder="FAR" onChange={handleChange}/>
//         </Row>
//       </Section>

//       {/* BUILDING */}
//       <Section title="Building">
//         <Row>
//           <Input name="floors" placeholder="Floors" onChange={handleChange}/>
//           <Input name="structure_type" placeholder="Structure Type" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="flooring" placeholder="Flooring" onChange={handleChange}/>
//           <Input name="interior" placeholder="Interior" onChange={handleChange}/>
//         </Row>
//         <Row>
//           <Input name="designing" placeholder="Designing" onChange={handleChange}/>
//           <Input name="builtup_area" placeholder="Builtup Area" onChange={handleChange}/>
//         </Row>

//         <Input name="construction_year" placeholder="Construction Year" onChange={handleChange}/>
//       </Section>

//       {/* REMARK */}
//       <Section title="Remark">
//         <textarea name="remark" placeholder="Enter remark..." style={textarea} onChange={handleChange}/>
//       </Section>

//       <button style={btn} onClick={handleSubmit}>
//         Submit
//       </button>
//     </div>
//   );
// };

// // ================= SMALL COMPONENTS =================

// const Section = ({ title, children }) => (
//   <div style={{ marginBottom: "15px" }}>
//     <h4>{title}</h4>
//     {children}
//   </div>
// );

// const Row = ({ children }) => (
//   <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
//     {children}
//   </div>
// );

// const Input = (props) => <input {...props} style={input} />;


// // ================= STYLES =================

// const card = { background: "#fff", padding: "15px", marginTop: "10px" };
// const table = { width: "100%" };
// const th = { padding: "10px" };
// const td = { padding: "10px" };

// const input = {
//   display: "block",
//   margin: "5px 0",
//   padding: "8px",
//   width: "100%",
// };

// const btn = {
//   background: "#4f6bed",
//   color: "#fff",
//   padding: "8px 12px",
//   border: "none",
//   cursor: "pointer",
// };



// const title = {
//   textAlign: "center",
//   marginBottom: "10px",
// };

// const textarea = {
//   width: "100%",
//   padding: "8px",
// };
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function ProjectAlloted() {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedProject, setSelectedProject] = useState(null);

//   const admin = JSON.parse(localStorage.getItem("admin"));

//   useEffect(() => {
//     if (!admin) return;

//     axios
//       .get(`https://api.d2associates.in//api/sitemaster/projects/${admin.id}`)
//       .then((res) => setProjects(res.data))
//       .catch((err) => console.log(err));
//   }, []);

//   const filtered = projects.filter(
//     (p) =>
//       p.project_name.toLowerCase().includes(search.toLowerCase()) ||
//       p.bank_name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Project Alloted</h2>

//       <div style={card}>
//         <table style={table}>
//           <thead>
//             <tr>
//               <th style={th}>#</th>
//               <th style={th}>Project Name</th>
//               <th style={th}>Bank</th>
//               <th style={th}>Branch</th>
//               <th style={th}>Date</th>
//               <th style={th}>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.map((p, i) => (
//               <tr key={p.id}>
//                 <td style={td}>{i + 1}</td>
//                 <td style={td}>{p.project_name}</td>
//                 <td style={td}>{p.bank_name}</td>
//                 <td style={td}>{p.branch}</td>
//                 <td style={td}>
//                   {new Date(p.created_at).toLocaleDateString()}
//                 </td>
//                 <td style={td}>
//                   <button style={btn} onClick={() => setSelectedProject(p)}>
//                     Add 
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {selectedProject && (
//         <PropertyForm projectId={selectedProject.id} />
//       )}
//     </div>
//   );
// }

// export default ProjectAlloted;



// const PropertyForm = ({ projectId }) => {
//   const [form, setForm] = useState({});
//   const [step, setStep] = useState(1);

//   const handleChange = (e) => {
//     const { name, value, type, checked, files } = e.target;

//     if (type === "file") {
//       setForm((prev) => ({
//         ...prev,
//         [name]: Array.from(files),
//       }));
//     } else {
//       setForm((prev) => ({
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//       }));
//     }
//   };

//  const handleSubmit = async () => {
//   try {
//     const formData = new FormData();


//     Object.keys(form).forEach((key) => {
//       if (key !== "documents" && key !== "site_images") {
//         formData.append(key, form[key]);
//       }
//     });


//     formData.set("is_same", form.is_same ? 1 : 0);
//     formData.set("sewerage", form.sewerage ? 1 : 0);
//     formData.set("electricity", form.electricity ? 1 : 0);


//     form.documents?.forEach((file) => {
//       formData.append("documents", file);
//     });


//     form.site_images?.forEach((file) => {
//       formData.append("site_images", file);
//     });


//     formData.append("project_id", projectId);

//    await axios.post("https://api.d2associates.in//api/property", formData, {
//   headers: {
//     "Content-Type": "multipart/form-data",
//   },
// });
//     alert("Saved Successfully");
//   } catch (err) {
//     console.log("ERROR =>", err);
//     alert("Error saving data");
//   }
// };

//   return (
//     <div style={card}>
//       <h2 style={title}>Property Inspection Form</h2>

//       {/* STEP 1 */}
//       {step === 1 && (
//         <div>
//           <h3>Upload Documents (Max 10)</h3>
//           <input
//             type="file"
//             name="documents"
//             multiple
//             accept=".pdf"
//             onChange={(e) => {
//               const files = Array.from(e.target.files).slice(0, 10);
//               setForm((prev) => ({ ...prev, documents: files }));
//             }}
//           />
          

//           <button style={btn} onClick={() => setStep(2)}>
//             Next
//           </button>
//         </div>
//       )}


//       {step === 2 && (
//         <>
    
   
// <div>

//           <Section title="Owner Details">
//             <Row>
//               <Input name="owner_name" placeholder="Owner Name" onChange={handleChange}/>
//               <Input name="owner_father" placeholder="Father Name" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="owner_contact" placeholder="Contact" onChange={handleChange}/>
//               <Input name="owner_address" placeholder="Address" onChange={handleChange}/>
//             </Row>
//           </Section>

//           <Section title="Borrower Details">
//             <label>
//               <input type="checkbox" name="is_same" onChange={handleChange}/> Same as Owner
//             </label>
//             <Row>
//               <Input name="borrower_name" placeholder="Borrower Name" onChange={handleChange}/>
//               <Input name="borrower_father" placeholder="Father Name" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="borrower_contact" placeholder="Contact" onChange={handleChange}/>
//               <Input name="borrower_address" placeholder="Address" onChange={handleChange}/>
//             </Row>
//           </Section>

//           <Section title="Location">
//             <Row>
//               <Input name="latitude" placeholder="Latitude" onChange={handleChange}/>
//               <Input name="longitude" placeholder="Longitude" onChange={handleChange}/>
//             </Row>
//           </Section>

//           <Section title="Property Details">
//             <Row>
//               <Input name="sale_deed_no" placeholder="Sale Deed No" onChange={handleChange}/>
//               <Input type="date" name="registration_date" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="purchase_amount" placeholder="Amount" onChange={handleChange}/>
//               <Input name="locality_price" placeholder="Locality Price" onChange={handleChange}/>
//             </Row>
//             <Input name="property_comment" placeholder="Property Comment" onChange={handleChange}/>
//           </Section>

//           <Section title="Land Details">
//             <Row>
//               <Input name="khata_no" placeholder="Khata No" onChange={handleChange}/>
//               <Input name="plot_no" placeholder="Plot No" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="village" placeholder="Village" onChange={handleChange}/>
//               <Input name="tahasil" placeholder="Tahasil" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="thana" placeholder="Thana" onChange={handleChange}/>
//               <Input name="district" placeholder="District" onChange={handleChange}/>
//             </Row>
//             <Input name="postal_address" placeholder="Postal Address" onChange={handleChange}/>
//           </Section>

//           <Section title="Area">
//             <Row>
//               <Input
//                 name="land_acre"
//                 placeholder="Acre"
//                 onChange={(e) => {
//                   const v = e.target.value;
//                   setForm({ ...form, land_acre: v, land_sqft: v * 43560 });
//                 }}
//               />
//               <Input name="land_sqft" value={form.land_sqft || ""} readOnly />
//             </Row>
//           </Section>

//           <Section title="Boundary">
//             <Row>
//               <Input name="east" placeholder="East" onChange={handleChange}/>
//               <Input name="west" placeholder="West" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="north" placeholder="North" onChange={handleChange}/>
//               <Input name="south" placeholder="South" onChange={handleChange}/>
//             </Row>
//           </Section>

//           <Section title="Property Type">
//             <Row>
//               <select name="property_types" style={input} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="Urban">Urban</option>
//                 <option value="Rural">Rural</option>
//                 <option value="Semi-Urban">Semi-Urban</option>
//               </select>
//             </Row>
//           </Section>

//           <Section title="Nearby">
//             <Row>
//               <Input name="landmark" placeholder="Landmark" onChange={handleChange}/>
//               <Input name="school_distance" placeholder="School Distance" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="hospital_distance" placeholder="Hospital Distance" onChange={handleChange}/>
//               <Input name="park_distance" placeholder="Park Distance" onChange={handleChange}/>
//             </Row>
//           </Section>

//           <Section title="Road">
//             <Row>
//               <Input name="road_width" placeholder="Road Width" onChange={handleChange}/>
//               <select name="road_type" style={input} onChange={handleChange}>
//                 <option>Bitumen</option>
//                 <option>Concrete</option>
//                 <option>Murrom</option>
//                 <option>Fly-ash</option>
//                 <option>Earthen</option>
//               </select>
//             </Row>

//             <label><input type="checkbox" name="sewerage" onChange={handleChange}/> Sewerage</label>
//             <label><input type="checkbox" name="electricity" onChange={handleChange}/> Electricity</label>
//           </Section>

//           <Section title="Approval">
//             <Row>
//               <select name="approval_status" style={input} onChange={handleChange}>
//                 <option>Approved</option>
//                 <option>Not Approved</option>
//               </select>
//               <div style={{ flex: 1 }}></div>
//             </Row>

//             <Row>
//               <Input name="approving_authority" placeholder="Authority" onChange={handleChange}/>
//               <Input name="approval_letter" placeholder="Approval Letter" onChange={handleChange}/>
//             </Row>

//             <Row>
//               <Input type="date" name="approval_date" onChange={handleChange}/>
//               <Input name="far" placeholder="FAR" onChange={handleChange}/>
//             </Row>
//           </Section>

//           <Section title="Building">
//             <Row>
//               <Input name="floors" placeholder="Floors" onChange={handleChange}/>
//               <Input name="structure_type" placeholder="Structure Type" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="flooring" placeholder="Flooring" onChange={handleChange}/>
//               <Input name="interior" placeholder="Interior" onChange={handleChange}/>
//             </Row>
//             <Row>
//               <Input name="designing" placeholder="Designing" onChange={handleChange}/>
//               <Input name="builtup_area" placeholder="Builtup Area" onChange={handleChange}/>
//             </Row>

//             <Input name="construction_year" placeholder="Construction Year" onChange={handleChange}/>
//           </Section>

//           <Section title="Remark">
//             <textarea name="remark" placeholder="Enter remark..." style={textarea} onChange={handleChange}/>
//           </Section>

//           <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//             <button style={btn} onClick={() => setStep(1)}>Back</button>
//             <button style={btn} onClick={() => setStep(3)}>Next</button>
//           </div>

//         </div>
//         </>
//       )}

  
//       {step === 3 && (
//         <div>
//           <h3>Upload Site Images (Max 5)</h3>
//           <input
//             type="file"
//             name="site_images"
//             multiple
//             accept="image/*"
//             onChange={(e) => {
//               const files = Array.from(e.target.files).slice(0, 5);
//               setForm((prev) => ({ ...prev, site_images: files }));
//             }}
//           />
          
// <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
//   <button style={btn} onClick={() => setStep(2)}>
//     Back
//   </button>

//   <button style={btn} onClick={handleSubmit}>
//     Submit
//   </button>
// </div>
//         </div>
//       )}
//     </div>
//   );
// };


// const Section = ({ title, children }) => (
//   <div style={{ marginBottom: "20px", width: "100%" }}>
//     <h4 style={{ marginBottom: "8px" }}>{title}</h4>
//     {children}
//   </div>
// );
// const Row = ({ children }) => (
//   <div
//     style={{
//       display: "flex",
//       gap: "10px",
//       marginBottom: "10px",
//       flexWrap: "wrap",
//       width: "100%",
//     }}
//   >
//     {children}
//   </div>
// );
// const Input = (props) => <input {...props} style={input} />;


// const card = { background: "#fff", padding: "15px", marginTop: "10px" ,  overflowX: "auto", };
// const table = { width: "100%" ,  minWidth: "650px", };
// const th = { padding: "10px" };
// const td = { padding: "10px" };
// const input = {
//   display: "block",
//   margin: "5px 0",
//   padding: "10px",
//   width: "100%",
//   flex: "1 1 250px",   // ✅ KEY FI
//   minWidth: "180px",   
//   boxSizing: "border-box",
// };
// const btn = {
//   background: "#D4c2BB",
//   color: "#7D4B3c",
//   padding: "8px 12px",
//   border: "none",
//   cursor: "pointer",
//     whiteSpace: "nowrap",
//   borderRadius:"9px"
// };

// const title = {
//   textAlign: "center",
//   marginBottom: "10px",
// };
// const textarea = {
//   width: "100%",
//   padding: "10px",
//   boxSizing: "border-box",
// };




import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ProjectAlloted() {
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);
  
  const admin = JSON.parse(localStorage.getItem("admin"));
  const fetchProjects = async () => {
  try {
    const res = await axios.get(
      `https://api.d2associates.in/sitemaster/projects/${admin.id}`
    );

    setProjects(res.data);

  } catch (err) {
    console.log(err);
  }
};

  // useEffect(() => {
  //   if (!admin) return;

  //   axios
  //     .get(`https://api.d2associates.in//sitemaster/projects/${admin.id}`)
  //     .then((res) => setProjects(res.data))
  //     .catch((err) => console.log(err));
  // }, []);

  useEffect(() => {
  if (!admin) return;

  fetchProjects();
}, []);
  const filtered = projects.filter(
    (p) =>
      p.project_name.toLowerCase().includes(search.toLowerCase()) ||
      p.bank_name.toLowerCase().includes(search.toLowerCase())
  );
  const handleEdit = async (project) => {

  try {

    const res = await axios.get(
      `https://api.d2associates.in/property/${project.property_id}`
    );

    setSelectedProject({
      ...project,
      formData: res.data
    });

  } catch (err) {

    console.log(err);

  }

};

  return (
    <div style={{ padding: "20px" }}>
      <h2>Project Alloted</h2>

      <div style={card}>
        <table style={table}>
          <thead>
            <tr>
              <th style={th}>#</th>
              <th style={th}>Project Name</th>
              <th style={th}>Bank</th>
              <th style={th}>Branch</th>
              <th style={th}>Date</th>
              <th style={th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((p, i) => (
              <tr key={p.id}>
                <td style={td}>{i + 1}</td>
                <td style={td}>{p.project_name}</td>
                <td style={td}>{p.bank_name}</td>
                <td style={td}>{p.branch}</td>
                <td style={td}>
                  {new Date(p.created_at).toLocaleDateString()}
                </td>
                {/* <td style={td}>
                  <button style={btn} onClick={() => setSelectedProject(p)}>
                    Add 
                  </button>
                </td> */}
                {/* <td style={td}>
  {!p.property_id ? (
    <button
      style={btn}
      onClick={() => setSelectedProject(p)}
    >
      Add
    </button>
  ) : (
    <span
      style={{
        color: "green",
        fontWeight: "bold",
      }}
    >
      Submitted
    </span>
  )}
</td> */}
<td style={td}>

  {!p.property_id ? (

    <button
      style={btn}
      onClick={() => setSelectedProject(p)}
    >
      Add
    </button>

  // ) : Number(p.isedit) === 1 ? (

  //   <button
  //     style={btn}
  //     onClick={() => handleEdit(p)}
  //   >
  //     Edit Form
  //   </button>
  ): Number(p.isedit) === 1 ? (

  <div>

    <button
      style={btn}
      onClick={() => handleEdit(p)}
    >
      Edit Form
    </button>

    {
      p.editremark && (
        <div
          style={{
            marginTop: "5px",
            color: "red",
            fontSize: "12px",
            fontWeight: "bold"
          }}
        >
          Remark: {p.editremark}
        </div>
      )
    }

  </div>



  ) : (

    <span
      style={{
        color: "green",
        fontWeight: "bold"
      }}
    >
      Submitted
    </span>

  )}

</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* {selectedProject && (
        <PropertyForm projectId={selectedProject.id} />
      )} */}

      {selectedProject && (
<PropertyForm
  projectId={selectedProject.id}
  editData={selectedProject.formData}
  onClose={() => setSelectedProject(null)}
    refreshProjects={fetchProjects}
/>
)}
      <ToastContainer 
  position="top-center" 
  autoClose={2000}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  pauseOnHover
/>
    </div>
  );
}

export default ProjectAlloted;



const PropertyForm = ({ projectId,onClose ,  editData, refreshProjects }) => {
  const [form, setForm] = useState({});
const [step, setStep] = useState(1);

const [existingDocuments, setExistingDocuments] = useState([]);
const [existingImages, setExistingImages] = useState([]);
useEffect(() => {

  if (editData) {

    setForm(editData);

    const docs =
      typeof editData.documents === "string"
        ? JSON.parse(editData.documents)
        : editData.documents || [];

    const images =
      typeof editData.site_images === "string"
        ? JSON.parse(editData.site_images)
        : editData.site_images || [];

    setExistingDocuments(docs);

    setExistingImages(images);

    // IMPORTANT
    setStep(3);

  }

}, [editData]);

// useEffect(() => {

//   if (editData) {

//     setForm(editData);

//     setExistingDocuments(
//       editData.documents
//         ? JSON.parse(editData.documents)
//         : []
//     );

//     setExistingImages(
//       editData.site_images
//         ? JSON.parse(editData.site_images)
//         : []
//     );

//   }

// }, [editData]);



  // const handleChange = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   if (type === "file") {
  //     setForm((prev) => ({
  //       ...prev,
  //       [name]: Array.from(files),
  //     }));
  //   } else {
  //     setForm((prev) => ({
  //       ...prev,
  //       [name]: type === "checkbox" ? checked : value,
  //     }));
  //   }
  // };
//   const handleFileUpload = (
//   e,
//   fieldName,
//   maxFiles
// ) => {

//   const selectedFiles = Array.from(
//     e.target.files
//   ).slice(0, maxFiles);

//   const validFiles = [];

//   for (let file of selectedFiles) {

//     const fileSizeInMB =
//       file.size / (1024 * 1024);

//     if (fileSizeInMB > 2) {

//       toast.error(
//         `${file.name} is larger than 2MB`
//       );

//     } else {

//       validFiles.push(file);

//     }

//   }

//   setForm((prev) => ({
//     ...prev,
//     [fieldName]: validFiles,
//   }));

// };
const handleFileUpload = (
  e,
  fieldName,
  maxFiles
) => {

  const allFiles = Array.from(
    e.target.files
  );

  // MAX FILE CHECK
  if (allFiles.length > maxFiles) {

    toast.error(
      `Maximum ${maxFiles} ${
        fieldName === "documents"
          ? "documents"
          : "images"
      } allowed`
    );

    return;
  }

//   const validFiles = [];

//   for (let file of allFiles) {

//     const fileSizeInMB =
//       file.size / (1024 * 1024);
//       console.log(fileSizeInMB)

//     // if (fileSizeInMB > 2) {

//     //   toast.error(
//     //     `${file.name} is larger than 2MB`
//     //   );

//     // } else {

//     //   validFiles.push(file);

//     // }
// if (fileSizeInMB > 5) {
//   toast.error(`${file.name} is larger than 5MB`);
// } else {
//   validFiles.push(file);
// }
//   }

//   setForm((prev) => ({
//     ...prev,
//     [fieldName]: validFiles,
//   }));
const validFiles = [];

for (let file of allFiles) {
  const fileSizeInMB = file.size / (1024 * 1024);

  if (fileSizeInMB > 5) {
    toast.error(`${file.name} is larger than 5MB`);

    // Input clear
    e.target.value = "";

    // Form state clear
    setForm((prev) => ({
      ...prev,
      [fieldName]: [],
    }));

    return; // Aage process mat karo
  }

  validFiles.push(file);
}

setForm((prev) => ({
  ...prev,
  [fieldName]: validFiles,
}));

};
const removeExistingDocument = (index) => {

  setExistingDocuments((prev) =>
    prev.filter((_, i) => i !== index)
  );

};

const removeExistingImage = (index) => {

  setExistingImages((prev) =>
    prev.filter((_, i) => i !== index)
  );

};


const handleChange = (e) => {
  const { name, value, type, checked, files } = e.target;

  if (type === "file") {
    setForm((prev) => ({
      ...prev,
      [name]: Array.from(files),
    }));
    return;
  }



  if (name === "is_same") {
    setForm((prev) => {
      if (checked) {
        return {
          ...prev,
          is_same: true,

          borrower_name: prev.owner_name || "",
          borrower_father: prev.owner_father || "",
          borrower_contact: prev.owner_contact || "",
          borrower_address: prev.owner_address || "",
        };
      } else {
        return {
          ...prev,
          is_same: false,

          borrower_name: "",
          borrower_father: "",
          borrower_contact: "",
          borrower_address: "",
        };
      }
    });
    return;
  }

  setForm((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

//  const handleSubmit = async () => {
//   console.log("SUBMIT CLICKED"); 
//   try {
//     const formData = new FormData();

//     Object.keys(form).forEach((key) => {
//       if (key !== "documents" && key !== "site_images") {
//       formData.append(key, form[key] ?? "");
//       }
//     });

//     formData.set("is_same", form.is_same ? 1 : 0);
//     formData.set("sewerage", form.sewerage ? 1 : 0);
//     formData.set("electricity", form.electricity ? 1 : 0);

//     form.documents?.forEach((file) => {
//       formData.append("documents", file);
//     });

//     form.site_images?.forEach((file) => {
//       formData.append("site_images", file);
//     });

//     formData.append("project_id", projectId);

//     // console.log("FORM DATA READY");

//     // const res = await axios.post(
//     //   "https://api.d2associates.in//property",
//     //   formData
//     // );
// if (form.id) {

//   await axios.put(
//     `https://api.d2associates.in//update-property/${projectId}`,
//     formData
//   );

// } else {

//   await axios.post(
//     "https://api.d2associates.in//property",
//     formData
//   );

// }
//     console.log("API RESPONSE =>", res.data); 

//     toast.success("Saved Successfully");
    
// setForm({});
// setStep(1);


// if (typeof onClose === "function") {
//   onClose();
// }
//   } catch (err) {
//     console.log("ERROR =>", err); 
//     toast.error("Error saving data");
//   }
// };


const handleSubmit = async () => {

  console.log("SUBMIT CLICKED");

  // Validation
  const documentsArray = Array.isArray(form.documents)
    ? form.documents
    : [];

  const imagesArray = Array.isArray(form.site_images)
    ? form.site_images
    : [];

  if (
    (form.documents !== undefined && documentsArray.length === 0) ||
    (form.site_images !== undefined && imagesArray.length === 0)
  ) {
    toast.error("Please upload valid files (Max 5MB)");
    return;
  }

  try {

    const formData = new FormData();

    Object.keys(form).forEach((key) => {

      if (
        key !== "documents" &&
        key !== "site_images"
      ) {
        formData.append(key, form[key] ?? "");
      }

    });

    formData.set("is_same", form.is_same ? 1 : 0);
    formData.set("sewerage", form.sewerage ? 1 : 0);
    formData.set("electricity", form.electricity ? 1 : 0);

    documentsArray.forEach((file) => {
      formData.append("documents", file);
    });

    imagesArray.forEach((file) => {
      formData.append("site_images", file);
    });

    formData.append("project_id", projectId);

    formData.append(
      "existingDocuments",
      JSON.stringify(existingDocuments)
    );

    formData.append(
      "existingImages",
      JSON.stringify(existingImages)
    );

    let res;

    if (form.id) {

      res = await axios.put(
        `https://api.d2associates.in/update-property/${projectId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

    } else {

      res = await axios.post(
        "https://api.d2associates.in/property",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

    }

    console.log("API RESPONSE =>", res.data);

    toast.success("Saved Successfully");

    await refreshProjects();

    setForm({});
    setStep(1);

    if (typeof onClose === "function") {
      onClose();
    }

  } catch (err) {

    console.log(err);
    toast.error("Error saving data");

  }

};
// const handleSubmit = async () => {

//   console.log("SUBMIT CLICKED");

//   try {

//     const formData = new FormData();

//     Object.keys(form).forEach((key) => {

//       if (
//         key !== "documents" &&
//         key !== "site_images"
//       ) {

//         formData.append(
//           key,
//           form[key] ?? ""
//         );

//       }

//     });

//     formData.set(
//       "is_same",
//       form.is_same ? 1 : 0
//     );

//     formData.set(
//       "sewerage",
//       form.sewerage ? 1 : 0
//     );

//     formData.set(
//       "electricity",
//       form.electricity ? 1 : 0
//     );

// const documentsArray = Array.isArray(form.documents)
//   ? form.documents
//   : [];

// documentsArray.forEach((file) => {
//   formData.append("documents", file);
// });

// const imagesArray = Array.isArray(form.site_images)
//   ? form.site_images
//   : [];

// imagesArray.forEach((file) => {
//   formData.append("site_images", file);
// });

//     // Project ID
//     formData.append(
//       "project_id",
//       projectId
//     );
//     formData.append(
//   "existingDocuments",
//   JSON.stringify(existingDocuments)
// );

// formData.append(
//   "existingImages",
//   JSON.stringify(existingImages)
// );

//     let res;

//     // UPDATE
//     if (form.id) {

//       res = await axios.put(
//         `https://api.d2associates.in/update-property/${projectId}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//     }

//     // CREATE
//     else {

//       res = await axios.post(
//         "https://api.d2associates.in/property",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//     }

//     console.log(
//       "API RESPONSE =>",
//       res.data
//     );

//     toast.success(
//       "Saved Successfully"
//     );
//   await refreshProjects();

//     // Reset Form
//     setForm({});

//     // Reset Step
//     setStep(1);

//     // Close Modal
//     if (typeof onClose === "function") {

//       onClose();

//     }

//   } catch (err) {

//     console.log(
//       "ERROR =>",
//       err
//     );

//     toast.error(
//       "Error saving data"
//     );

//   }

// };
  return (
    <div style={card}>
      <h2 style={title}>Property Inspection Form</h2>

  
      {step === 1 && (
        <div>
          <h3>Upload Documents (Max 10)</h3>
          {/* <input
            type="file"
            name="documents"
            multiple
            accept=".pdf"
          onChange={(e) =>
  handleFileUpload(
    e,
    "documents",
    10
  )
}
          /> */}
          <input
  type="file"
  name="documents"
  multiple
  accept=".pdf"
  onChange={(e) =>
    handleFileUpload(
      e,
      "documents",
      10
    )
  }
/>

{
  existingDocuments.length > 0 && (
    <div style={{ marginTop: "20px" }}>
{/* 
      <h4>Existing PDFs</h4> */}

      {
        existingDocuments.map((file, index) => (

          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "10px"
            }}
          >

            <a
              // href={`https://api.d2associates.in//${file}`}
// href={`https://api.d2associates.in//dUploads/${file}`}
href={`https://api.d2associates.in/dUploads/${file.replace("dUploads/", "")}`}
              target="_blank"
              rel="noreferrer"
            >
              {file}
            </a>

            <button
              type="button"
              onClick={() =>
                removeExistingDocument(index)
              }
              style={{
                background: "red",
                color: "#fff",
                border: "none",
                padding: "5px 10px"
              }}
            >
              Delete
            </button>

          </div>

        ))
      }

    </div>
  )
}
          

          <button style={btn} onClick={() => setStep(2)}>
            Next
          </button>
        </div>
      )}


      {step === 2 && (
        <>
    
   
<div>

          <Section title="Owner Details">
  <Row>
    <Input name="owner_name" value={form.owner_name || ""} placeholder="Owner Name" onChange={handleChange}/>
    <Input name="owner_father" value={form.owner_father || ""} placeholder="Father Name" onChange={handleChange}/>
  </Row>
  <Row>
    <Input name="owner_contact" value={form.owner_contact || ""} placeholder="Contact" onChange={handleChange}/>
    <Input name="owner_address" value={form.owner_address || ""} placeholder="Address" onChange={handleChange}/>
  </Row>
</Section>
          <Section title="Borrower Details">
  <label>
    <input type="checkbox" name="is_same" onChange={handleChange}/> Same as Owner
  </label>

  <Row>
    <Input name="borrower_name" value={form.borrower_name || ""} placeholder="Borrower Name" onChange={handleChange}/>
    <Input name="borrower_father" value={form.borrower_father || ""} placeholder="Father Name" onChange={handleChange}/>
  </Row>

  <Row>
    <Input name="borrower_contact" value={form.borrower_contact || ""} placeholder="Contact" onChange={handleChange}/>
    <Input name="borrower_address" value={form.borrower_address || ""} placeholder="Address" onChange={handleChange}/>
  </Row>
</Section>

          <Section title="Location">
            <Row>
              <Input name="latitude" placeholder="Latitude" onChange={handleChange}/>
              <Input name="longitude" placeholder="Longitude" onChange={handleChange}/>
            </Row>
          </Section>

          <Section title="Property Details">
            <Row>
              <Input name="sale_deed_no" placeholder="Sale Deed No" onChange={handleChange}/>
              <Input type="date" name="registration_date" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="purchase_amount" placeholder="Amount" onChange={handleChange}/>
              <Input name="locality_price" placeholder="Locality Price" onChange={handleChange}/>
            </Row>
            <Input name="property_comment" placeholder="Property Comment" onChange={handleChange}/>
          </Section>

          <Section title="Land Details">
            <Row>
              <Input name="khata_no" placeholder="Khata No" onChange={handleChange}/>
              <Input name="plot_no" placeholder="Plot No" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="village" placeholder="Village" onChange={handleChange}/>
              <Input name="tahasil" placeholder="Tahasil" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="thana" placeholder="Thana" onChange={handleChange}/>
              <Input name="district" placeholder="District" onChange={handleChange}/>
            </Row>
            <Input name="postal_address" placeholder="Postal Address" onChange={handleChange}/>
          </Section>

          <Section title="Area">
            <Row>
              <Input
                name="land_acre"
                placeholder="Acre"
                onChange={(e) => {
                  const v = e.target.value;
setForm((prev) => ({
  ...prev,
  land_acre: v,
  land_sqft: v * 43560,
}));
                }}
              />
              <Input name="land_sqft" value={form.land_sqft || ""} readOnly />
            </Row>
          </Section>

          <Section title="Boundary">
            <Row>
              <Input name="east" placeholder="East" onChange={handleChange}/>
              <Input name="west" placeholder="West" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="north" placeholder="North" onChange={handleChange}/>
              <Input name="south" placeholder="South" onChange={handleChange}/>
            </Row>
          </Section>

          <Section title="Property Type">
            <Row>
              <select name="property_types" style={input} onChange={handleChange}>
                <option value="">Select</option>
                <option value="Urban">Urban</option>
                <option value="Rural">Rural</option>
                <option value="Semi-Urban">Semi-Urban</option>
              </select>
            </Row>
          </Section>

          <Section title="Nearby">
            <Row>
              <Input name="landmark" placeholder="Landmark" onChange={handleChange}/>
              <Input name="school_distance" placeholder="School Distance" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="hospital_distance" placeholder="Hospital Distance" onChange={handleChange}/>
              <Input name="park_distance" placeholder="Park Distance" onChange={handleChange}/>
            </Row>
          </Section>

          <Section title="Road">
            <Row>
              <Input name="road_width" placeholder="Road Width" onChange={handleChange}/>
              <select name="road_type" style={input} onChange={handleChange}>
                <option>Bitumen</option>
                <option>Concrete</option>
                <option>Murrom</option>
                <option>Fly-ash</option>
                <option>Earthen</option>
              </select>
            </Row>

            <label><input type="checkbox" name="sewerage" onChange={handleChange}/> Sewerage</label>
            <label><input type="checkbox" name="electricity" onChange={handleChange}/> Electricity</label>
          </Section>

          <Section title="Approval">
            <Row>
              <select name="approval_status" style={input} onChange={handleChange}>
                <option>Approved</option>
                <option>Not Approved</option>
              </select>
              <div style={{ flex: 1 }}></div>
            </Row>

            <Row>
              <Input name="approving_authority" placeholder="Authority" onChange={handleChange}/>
              <Input name="approval_letter" placeholder="Approval Letter" onChange={handleChange}/>
            </Row>

            <Row>
              <Input type="date" name="approval_date" onChange={handleChange}/>
              <Input name="far" placeholder="FAR" onChange={handleChange}/>
            </Row>
          </Section>

          <Section title="Building">
            <Row>
              <Input name="floors" placeholder="Floors" onChange={handleChange}/>
              <Input name="structure_type" placeholder="Structure Type" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="flooring" placeholder="Flooring" onChange={handleChange}/>
              <Input name="interior" placeholder="Interior" onChange={handleChange}/>
            </Row>
            <Row>
              <Input name="designing" placeholder="Designing" onChange={handleChange}/>
              <Input name="builtup_area" placeholder="Builtup Area" onChange={handleChange}/>
            </Row>

            <Input name="construction_year" placeholder="Construction Year" onChange={handleChange}/>
          </Section>

          <Section title="Remark">
            <textarea name="remark" placeholder="Enter remark..." style={textarea} onChange={handleChange}/>
          </Section>

          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <button style={btn} onClick={() => setStep(1)}>Back</button>
            <button style={btn} onClick={() => setStep(3)}>Next</button>
          </div>

        </div>
        </>
      )}

  
      {step === 3 && (
        <div>
          <h3>Upload Site Images (Max 10)</h3>
          {/* <input
            type="file"
            name="site_images"
            multiple
            accept="image/*"
          onChange={(e) =>
  handleFileUpload(
    e,
    "site_images",
    10
  )
}
          /> */}
          <input
  type="file"
  name="site_images"
  multiple
  accept="image/*"
  onChange={(e) =>
    handleFileUpload(
      e,
      "site_images",
      10
    )
  }
/>

{
  existingImages.length > 0 && (

    <div
      style={{
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        marginTop: "20px"
      }}
    >

      {
        existingImages.map((img, index) => (

          <div
            key={index}
            style={{
              position: "relative"
            }}
          >

  <img
  // src={`https://api.d2associates.in//dUploads/${img}`}
  src={`https://api.d2associates.in/dUploads/${img.replace("dUploads/", "")}`}
  alt=""
  style={{
    width: "120px",
    height: "120px",
    objectFit: "cover",
    borderRadius: "10px"
  }}
  onError={(e) => {
    console.log("IMAGE NOT FOUND =>", img);
  }}
/>

            <button
              type="button"
              onClick={() =>
                removeExistingImage(index)
              }
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                background: "red",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "25px",
                height: "25px",
                cursor: "pointer"
              }}
            >
              X
            </button>

          </div>

        ))
      }

    </div>

  )
}
          
<div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
  <button style={btn} onClick={() => setStep(2)}>
    Back
  </button>

  <button style={btn} onClick={handleSubmit}>
    Submit
  </button>
</div>
        </div>
      )}
    </div>
  );
};


const Section = ({ title, children }) => (
  <div style={{ marginBottom: "20px", width: "100%" }}>
    <h4 style={{ marginBottom: "8px" }}>{title}</h4>
    {children}
  </div>
);
const Row = ({ children }) => (
  <div
    style={{
      display: "flex",
      gap: "10px",
      marginBottom: "10px",
      flexWrap: "wrap",
      width: "100%",
    }}
  >
    {children}
  </div>
);
const Input = (props) => <input {...props} style={input} />;


const card = { background: "#fff", padding: "15px", marginTop: "10px" ,  overflowX: "auto", };
const table = { width: "100%" ,  minWidth: "650px", };
const th = { padding: "10px" };
const td = { padding: "10px" };
const input = {
  display: "block",
  margin: "5px 0",
  padding: "10px",
  width: "100%",
  flex: "1 1 250px",   
  minWidth: "180px",   
  boxSizing: "border-box",
};
const btn = {
  background: "#D4c2BB",
  color: "#7D4B3c",
  padding: "8px 12px",
  border: "none",
  cursor: "pointer",
    whiteSpace: "nowrap",
  borderRadius:"9px"
};

const title = {
  textAlign: "center",
  marginBottom: "10px",
};
const textarea = {
  width: "100%",
  padding: "10px",
  boxSizing: "border-box",
};